import ServicePage from "@/components/ServicePage";

export default function Servicing() {
  return (
    <ServicePage
      type="Servicing"
      path="/servicing"
      title="Keep your eBike running like new"
      subtitle="Regular professional servicing protects your warranty, your safety and your investment."
      image="https://images.unsplash.com/photo-1562615193-cbeef074a501?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
      seoTitle="eBike Servicing — Professional Electric Bike Service Plans"
      seoDesc="Professional electric bike servicing in Kent. Tune-ups, full services & warranty maintenance by certified technicians. Book your ebike service online at Ebikes&Gear."
      cta="Book a Service"
      intro={{
        heading: "Service plans for every rider",
        text: "Like any precision machine, your ebike performs best with regular care. Our service plans cover everything from quick safety tune-ups to comprehensive overhauls — all carried out by certified technicians using approved diagnostics.",
      }}
      perks={["Multi-point safety inspection", "Firmware & motor updates", "Drivetrain deep clean", "Brake & gear adjustment", "Battery health report", "Warranty-compliant service log"]}
      packages={{
        heading: "Service packages",
        items: [
          { name: "Essential Tune-Up", desc: "Safety check, brakes, gears, tyres", price: "£49" },
          { name: "Full Service", desc: "Complete drivetrain & electrical service", price: "£99" },
          { name: "Premium Overhaul", desc: "Strip, deep clean, rebuild & report", price: "£179" },
          { name: "Annual Care Plan", desc: "2 services + priority booking", price: "£169/yr" },
        ],
      }}
    />
  );
}
